import { Department } from "../models/Departments/Department";
import { DepartmentBrand } from "../models/Departments/DepartmentBrand";
import { DepartmentType } from "../models/Departments/DepartmentType";
import Api from "./../config/api";

export class DepartmentsActions {
    static get(): Promise<Department[]> {
        return Api.get("/departments")
            .then((data: any) => { return data.data })
            .catch((error) => console.log(error))
    }

    static getTypes(departmentId: number): Promise<DepartmentType[]> {
        return Api.get("/departments/" + departmentId + "/types")
            .then((data: any) => { return data.data })
            .catch((error) => console.log(error))
    }

    static getBrands(departmentId: number): Promise<DepartmentBrand[]> {
        return Api.get("/departments/" + departmentId + "/brands")
            .then((data: any) => { return data.data })
            .catch((error) => console.log(error))
    }
}